import React from "react";
import {Container} from "react-bootstrap";
import TheLifecycleOfSoftwareObjects from "./chiang/TheLifecycleOfSoftwareObjects";

function Translation() {
    return (
        <Container>
            <h2 className="text-center">Reading</h2>
            <h5>Why?</h5>
            <p>
                Reading is, and has always been, a performance.
            </p>
            <p>
                In ancient times, literacy alone was enough to indicate membership in a certain social class--
                whether it be an oracle practicing divination in the Shang dynasty or Plato and Socrates debating poetry
                as their slaves worked the fields.
            </p>
            <p>
                As the drive for universal literacy largely removed the ability to interpret written documents as a class
                distinction, class identity is still formed through many choices in how reading is performed--
                in terms of:
                <ul>
                    <li><em>what</em> is read, i.e.:</li>
                    <ul>
                        <li>romance</li>
                        <li>Tumblr</li>
                        <li>"business" books</li>
                        <li>a used copy of Edmund Spenser's <em>The Faerie Queene</em> found at a secondhand bookstore</li>
                    </ul>
                    <li><em>how</em> it's read, i.e.:</li>
                    <ul>
                        <li>as part of a social media challenge to read a certain number of "books" every month</li>
                        <li>on a manga website, while simultaneously listening to music and texting a group of friends</li>
                        <li>in hardcover books purchased on amazon.com, as part of a book club that meets every other Tuesday</li>
                        <li>every morning at 7am, out loud, taking turns for each verse, as part of a daily familial ritual</li>
                    </ul>
                    <li>how the reading is <em>publicly conveyed</em>, i.e.:
                        <ul>
                            <li>sung in a mass</li>
                            <li>chanted from a minaret</li>
                            <li>posted on TikTok</li>
                            <li>published in a journal on Comparative American Studies</li>
                        </ul>
                    </li>
                </ul>
            </p>
            <p>
                I've come to find, suddenly, somehow or other, that the <em>what</em> and <em>how</em> of my reading
                practice doesn't exist anymore--that is, no one else seems to be doing it--and
                the <em>conveying</em> simply doesn't happen.
            </p>
            <p>
                That is, reading has become for me a largely private, eccentric, hermit-like practice.
                As a result of this, I had to get a job in tech.
            </p>
            <p>
                I've noticed more and more incredibly talented and eccentric people also getting jobs in tech,
                participating in "boot camps", or otherwise finding their way into corporate jobs.
            </p>
            <p>
                Does that one's boss know that he wrote a piece for bassoon that exclusively uses multiphonics?
                Was her thesis on Roland Barthes just a bizarre side quest occasioned by an obsolete educational
                institution?
            </p>
            <p>
                What's a good first Tinder message to send to a girl whose bio lists Wittgenstein as her main interest?
            </p>
            <p>
                It all feels quite absurd, and irrelevant, and lonely. Nonetheless, I keep privately performing my
                eccentric, hermit-esque reading practices--and I think quite a lot of people still do the same,
                to varying degrees and each with their own flavor.
            </p>
            <p>
                As a way to externalize my thoughts, and make them available to anyone who cares to follow in some of
                the same byways, I want to start a journal of my reading (& listening & watching & playing). So, the
                below is a collection of "book report" style reactions to various things I've come across that are
                meaningful to me, roughly in order of whenever I sat down and wrote about them.
            </p>
            <hr/>
            <TheLifecycleOfSoftwareObjects />
        </Container>
    )
}

export default Translation;
